import React from "react";
import styled from "styled-components";
import { WHEN_LG, WHEN_MD, WHEN_XL, PALETTE } from "../constants";
import Heading from "./SectionHeading";
import Subheading from "./SectionSubheading";
import { StaticImage } from "gatsby-plugin-image";
import ContentContainer from "./ContentContainer";

const OuterContainer = styled(ContentContainer)`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  flex-direction: column-reverse;
  background-color: ${PALETTE.PRIMARY["100"]};

  ${WHEN_MD} {
    flex-direction: row;
  }
`;

const InnerLeftContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  ${WHEN_MD} {
    padding-right: 2rem;
  }
`;
const InnerRightContainer = styled.div`
  flex: 1;
  text-align: center;
  ${WHEN_MD} {
    padding-left: 2rem;
    text-align: left;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 400px;
`;
export default function OurStory() {
  return (
    <OuterContainer>
      <InnerLeftContainer>
        <ImageContainer>
          <StaticImage
            src="../images/undraw-thought-process.svg"
            alt="our story"
            placeholder="blurred"
            objectFit="contain"
            style={{ width: "100%", height: "100%" }}
          />
        </ImageContainer>
      </InnerLeftContainer>
      <InnerRightContainer>
        <Heading>Why NoFi?</Heading>
        <StaticImage
          src="../images/our-story-stroke-1.svg"
          alt="stroke"
          placeholder="blurred"
          objectFit="contain"
          width={250}
          height={15}
        />
        <p className="text-md mt-2 u-text-left">
          Notion is an incredibly powerful tool. Our team uses it every day to
          run our lives. And yet, when it came to syncing our personal financial
          data with Notion, we weren't able to find a product that actually
          worked 😞.
        </p>
        <p className="text-md u-text-left">
          That's why we created NoFi. We hope that you will get as much value
          and enjoyment out of NoFi as our team, friends, and family have!
        </p>
      </InnerRightContainer>
    </OuterContainer>
  );
}
